/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { Button } from '@material-ui/core';
import React from 'react';
import { saveAs } from 'file-saver';
import moment from 'moment';
import examType1Services from '../../redux/services/examType1Services';
import { createXlsx } from '../../helpers/utils';

const zip = require('jszip')();

const DownloadQuizsDetails = ({ examData }) => {
  const formatType = (type) => {
    let formatedType = '';
    switch (type) {
      case 'mcq':
        formatedType = 'Question à choix multiples';
        return formatedType;
      case 'tof':
        formatedType = 'Vrai ou faux';
        return formatedType;
      case 'fillblank':
        formatedType = 'Remplir les blancs';
        return formatedType;
      case 'd&d':
        formatedType = 'Drag and drop';
        return formatedType;
      default:
        // eslint-disable-next-line no-unused-expressions
        null;
    }
    return formatedType;
  };

  const handleDownload = async () => {
    const testsArr = [];
    await Promise.all(examData.map(async (test) => {
      try {
        const res = await examType1Services.getTestById(test.testId);
        testsArr.push({ ...test, res });
      } catch (e) {
        // console.log(e);
      }
    }));
    const today = new Date();
    testsArr.forEach((test) => {
      //   let KNTotal = 0;
      //   let RCTotal = 0;
      const finalResults = [];
      test.res?.answers?.forEach((answer) => {
        let points = 0;
        const answersArr = [];

        answer.question.answers?.forEach((item, index) => {
          const answerItem = { ...item, isChosen: false };
          answer.answerIndex?.forEach((elem) => {
            if (elem === index) {
              answerItem.isChosen = true;
            }
          });
          answersArr.push(answerItem);
        });
        if (answer.valid) {
          points = answer.question.coefficient;
        }
        const testObj = {
          question: answer.question?.name || '',
          type: formatType(answer.question?.type) || '',
          catégorie: answer.question?.category || '',
          points,
          created_at: answer.created_at ? moment(new Date(answer.created_at)).format('DD-MM-YYYY - HH:mm') : 'n/a',
        };
        testObj.points += '/';
        testObj.points += answer.question.coefficient;

        if (answersArr && answersArr.length > 0) {
          answersArr.forEach((answerStr, index) => {
            if (answerStr && answerStr?.text) {
              let name = 'réponse ';
              name += index + 1;
              if (!answerStr.isChosen && answerStr.isRight) {
                answerStr.text += ' (bonne réponse)';
              } if (answerStr.isChosen && answerStr.isRight) {
                answerStr.text += ' (bonne réponse et réponse sélectionnée)';
              } if (answerStr.isChosen && !answerStr.isRight) {
                answerStr.text += ' (réponse sélectionnée)';
              }
              testObj[name] = answerStr.text;
            }
          });
        }
        finalResults.push(testObj);
      });
      finalResults.push({ question: '' }, { question: `Note: ${test.note}/${test.total}` });
      const xlsx = createXlsx(finalResults);
      zip.file(`${`${test.name}_${test.firstname}`}.xlsx`, xlsx);
    });
    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `Resultats_excel_${today}.zip`);
    });
  };
  return (
    <Button disableElevation variant="contained" color="primary" size="small" onClick={handleDownload}>Download papers</Button>
  );
};

export default DownloadQuizsDetails;
